import React, { useCallback, useState } from "react";

import { Button, Icon, Message, Modal } from "semantic-ui-react";

import CardSettingPackage, {
  CardSettingPackageProps,
} from "react-lib/apps/HISV3/HCU/CardSettingPackage";

import ModBackupReceiptTemplate from "./ModBackupReceiptTemplate";

import "./CardMeSettingPackage.scss";

const CardMeSettingPackage = (props: CardSettingPackageProps) => {
  const [openBackupReceipt, setOpenBackupReceipt] = useState(false);
  const runPackageSequence = useCallback(
    (params: any) => {
      if (params.sequence === "SettingPackage" && ["NEW_PACKAGE", "CLEAR"].includes(params.action))
        props.setProp("SettingPackageSequence.prefillMessage", undefined);
      return props.runSequence({
        ...params,
        ...(params.sequence === "SettingPackage" &&
          params.restart &&
          !params.action && {
            acceptServicePrefill: true,
            pendingPrefill: props.SettingPackageSequence?.pendingPrefill,
          }),
      });
    },
    [props.runSequence, props.setProp, props.SettingPackageSequence?.pendingPrefill]
  );

  const handleClose = () => {
    runPackageSequence({ sequence: "SettingPackage", action: "CLEAR" });
  };

  return (
    <div className="CardMeSettingPackage">
      {/* หัวข้อของการ์ดถูกซ่อนแล้ววาดเองที่นี่ เพื่อวางปุ่มดาวน์โหลดไว้แถวเดียวกัน (#86100) */}
      <div className="setting-package-header">
        <div className="title">ตั้งค่าสำหรับเปิดขาย Package</div>

        <Button basic color="green" onClick={() => setOpenBackupReceipt(true)}>
          <Icon name="download" />
          ดาวน์โหลด Excel ราคาแพ็กเกจ (ออกใบเสร็จแบบ Manual)
        </Button>
      </div>

      <ModBackupReceiptTemplate
        open={openBackupReceipt}
        setProp={props.setProp}
        runSequence={props.runSequence}
        buttonLoadCheck={props.buttonLoadCheck}
        onClose={() => setOpenBackupReceipt(false)}
      />

      <CardSettingPackage
        setProp={props.setProp}
        onEvent={props.onEvent}
        // seq
        runSequence={runPackageSequence}
        SettingPackageSequence={props.SettingPackageSequence}
        // CommonInterface
        buttonLoadCheck={props.buttonLoadCheck}
        errorMessage={props.errorMessage}
        searchedItemListWithKey={props.searchedItemListWithKey}
        showPackageCategory
        showPackageDisplay
        showLabInfoColumns
        hideDetail
        hideTitle
        hideSearchBoxDropdown
        filterByDivision
        // options
        masterOptions={props.masterOptions}
        masterData={props.masterData}
        languageUX={props.languageUX}
      />
      <Modal
        open={!!props.SettingPackageSequence?.showDetail}
        style={{ width: "fit-content" }}
        closeOnDimmerClick
        closeIcon
        onClose={handleClose}
      >
        <div className="CardMeSettingPackage">
          {props.SettingPackageSequence?.prefillMessage && (
            <Message warning role="status">
              {props.SettingPackageSequence.prefillMessage}
            </Message>
          )}
          <CardSettingPackage
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={runPackageSequence}
            SettingPackageSequence={props.SettingPackageSequence}
            // CommonInterface
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            searchedItemListWithKey={props.searchedItemListWithKey}
            restart={false}
            showPackageCategory
            showPackageDisplay
            showLabInfoColumns
            showZeroCount
            hideSubSearchPackage
            hideTitle
            filterByDivision
            // options
            masterOptions={props.masterOptions}
            masterData={props.masterData}
            languageUX={props.languageUX}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CardMeSettingPackage;
